import { ToastNotification } from '../blocks/toast-notification.block.jsx';

export const ToastOverlay = ({ toasts }) => (
  <div
    className="fixed top-6 right-6 z-[200] flex flex-col gap-4"
    role="region"
    aria-label="Notifications"
  >
    {toasts.map(toast => (
      <ToastNotification key={toast.id} {...toast} />
    ))}
  </div>
);